import { ROUTES_CONFIG } from "src/constants/routesConfig";
import { NavItem } from "src/types";

export const navItems: NavItem[] = [
  {
    label: "Purchase Order",
    roleRequired: ROUTES_CONFIG.purchaseOrdersDashboard.roleRequired,
    children: [
      {
        label: ROUTES_CONFIG.purchaseOrdersDashboard.displayName,
        path: ROUTES_CONFIG.purchaseOrdersDashboard.path,
        roleRequired: ROUTES_CONFIG.purchaseOrdersDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.transitPurchaseOrdersDashboard.displayName,
        path: ROUTES_CONFIG.transitPurchaseOrdersDashboard.path,
        roleRequired: ROUTES_CONFIG.transitPurchaseOrdersDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.subPurchaseOrdersDashboard.displayName,
        path: ROUTES_CONFIG.subPurchaseOrdersDashboard.path,
        roleRequired: ROUTES_CONFIG.subPurchaseOrdersDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.transferOrdersDashboard.displayName,
        path: ROUTES_CONFIG.transferOrdersDashboard.path,
        roleRequired: ROUTES_CONFIG.transferOrdersDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.createPurchaseOrder.displayName,
        path: ROUTES_CONFIG.createPurchaseOrder.path,
        roleRequired: ROUTES_CONFIG.createPurchaseOrder.roleRequired
      },
      {
        label: ROUTES_CONFIG.uploadPurchaseOrders.displayName,
        path: ROUTES_CONFIG.uploadPurchaseOrders.path,
        roleRequired: ROUTES_CONFIG.uploadPurchaseOrders.roleRequired
      },
      {
        label: ROUTES_CONFIG.sendPurchaseOrder.displayName,
        path: ROUTES_CONFIG.sendPurchaseOrder.path,
        roleRequired: ROUTES_CONFIG.sendPurchaseOrder.roleRequired
      },
      {
        label: ROUTES_CONFIG.updatePurchaseOrderConfirmation.displayName,
        path: ROUTES_CONFIG.updatePurchaseOrderConfirmation.path,
        roleRequired: ROUTES_CONFIG.updatePurchaseOrderConfirmation.roleRequired
      },
      {
        label: ROUTES_CONFIG.amendPurchaseOrder.displayName,
        path: ROUTES_CONFIG.amendPurchaseOrder.path,
        roleRequired: ROUTES_CONFIG.amendPurchaseOrder.roleRequired
      },
      {
        label: ROUTES_CONFIG.createChildPurchaseOrder.displayName,
        path: ROUTES_CONFIG.createChildPurchaseOrder.path,
        roleRequired: ROUTES_CONFIG.createChildPurchaseOrder.roleRequired
      },
      {
        label: ROUTES_CONFIG.reviewPurchaseOrderConfirmation.displayName,
        path: ROUTES_CONFIG.reviewPurchaseOrderConfirmation.path,
        roleRequired: ROUTES_CONFIG.reviewPurchaseOrderConfirmation.roleRequired
      },
      {
        label: ROUTES_CONFIG.updatePurchaseOrderShipmentDetails.displayName,
        path: ROUTES_CONFIG.updatePurchaseOrderShipmentDetails.path,
        roleRequired: ROUTES_CONFIG.updatePurchaseOrderShipmentDetails.roleRequired
      },
      {
        label: ROUTES_CONFIG.updatePurchaseOrderInvoice.displayName,
        path: ROUTES_CONFIG.updatePurchaseOrderInvoice.path,
        roleRequired: ROUTES_CONFIG.updatePurchaseOrderInvoice.roleRequired
      },
      {
        label: ROUTES_CONFIG.resolveGXOError.displayName,
        path: ROUTES_CONFIG.resolveGXOError.path,
        roleRequired: ROUTES_CONFIG.resolveGXOError.roleRequired
      }
    ]
  },
  {
    label: "Active Ants",
    roleRequired: ROUTES_CONFIG.activeAntsPurchaseOrdersDashboard.roleRequired,
    children: [
      {
        label: "AA Purchase Orders",
        path: ROUTES_CONFIG.activeAntsPurchaseOrdersDashboard.path,
        roleRequired: ROUTES_CONFIG.activeAntsPurchaseOrdersDashboard.roleRequired
      },
      {
        label: "AA Warehouse Check-Ins",
        path: ROUTES_CONFIG.activeAntsWarehouseCheckInsDashboard.path,
        roleRequired: ROUTES_CONFIG.activeAntsWarehouseCheckInsDashboard.roleRequired
      },
      {
        label: "AA Goods-in Exports",
        path: ROUTES_CONFIG.activeAntsGoodsInExports.path,
        roleRequired: ROUTES_CONFIG.activeAntsGoodsInExports.roleRequired
      },
      {
        label: ROUTES_CONFIG.resolveAAError.displayName,
        path: ROUTES_CONFIG.resolveAAError.path,
        roleRequired: ROUTES_CONFIG.resolveAAError.roleRequired
      }
    ]
  },
  {
    label: "Finance",
    roleRequired: ["HEALF_TEAM"],
    children: [
      {
        label: ROUTES_CONFIG.invoiceExports.displayName,
        path: ROUTES_CONFIG.invoiceExports.path,
        roleRequired: ROUTES_CONFIG.invoiceExports.roleRequired
      },
      {
        label: ROUTES_CONFIG.hmrcExchangeRates.displayName,
        path: ROUTES_CONFIG.hmrcExchangeRates.path,
        roleRequired: ROUTES_CONFIG.hmrcExchangeRates.roleRequired
      }
    ]
  },
  {
    label: "Warehouse",
    roleRequired: ROUTES_CONFIG.warehouseCheckInsDashboard.roleRequired,
    children: [
      {
        label: ROUTES_CONFIG.warehouseCheckInsDashboard.displayName,
        path: ROUTES_CONFIG.warehouseCheckInsDashboard.path,
        roleRequired: ROUTES_CONFIG.warehouseCheckInsDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.checkInPurchaseOrder.displayName,
        path: ROUTES_CONFIG.checkInPurchaseOrder.path,
        roleRequired: ROUTES_CONFIG.checkInPurchaseOrder.roleRequired
      },
      {
        label: ROUTES_CONFIG.checkInUnknownArrival.displayName,
        path: ROUTES_CONFIG.checkInUnknownArrival.path,
        roleRequired: ROUTES_CONFIG.checkInUnknownArrival.roleRequired
      },
      {
        label: ROUTES_CONFIG.goodsInExports.displayName,
        path: ROUTES_CONFIG.goodsInExports.path,
        roleRequired: ROUTES_CONFIG.goodsInExports.roleRequired
      },
      {
        label: ROUTES_CONFIG.purchaseOrderBarcodeLookup.displayName,
        path: ROUTES_CONFIG.purchaseOrderBarcodeLookup.path,
        roleRequired: ROUTES_CONFIG.purchaseOrderBarcodeLookup.roleRequired
      }
    ]
  },
  {
    label: "Claims",
    roleRequired: ["WAREHOUSE", "HEALF_OPERATIONS_TEAM", "VENDOR"],
    children: [
      {
        label: ROUTES_CONFIG.claimsDashboard.displayName,
        path: ROUTES_CONFIG.claimsDashboard.path,
        roleRequired: ROUTES_CONFIG.claimsDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.createClaim.displayName,
        path: ROUTES_CONFIG.createClaim.path,
        roleRequired: ROUTES_CONFIG.createClaim.roleRequired
      }
    ]
  },
  {
    label: "Relabelling",
    roleRequired: ["RELABELLING", "HEALF_OPERATIONS_TEAM"],
    children: [
      {
        label: ROUTES_CONFIG.euRelabelCheckIn.displayName,
        path: ROUTES_CONFIG.euRelabelCheckIn.path,
        roleRequired: ROUTES_CONFIG.euRelabelCheckIn.roleRequired
      },
      {
        label: ROUTES_CONFIG.relabelCaseBuilder.displayName,
        path: ROUTES_CONFIG.relabelCaseBuilder.path,
        roleRequired: ROUTES_CONFIG.relabelCaseBuilder.roleRequired
      },
      {
        label: ROUTES_CONFIG.relabelCaseTracking.displayName,
        path: ROUTES_CONFIG.relabelCaseTracking.path,
        roleRequired: ROUTES_CONFIG.relabelCaseTracking.roleRequired
      },
      {
        label: ROUTES_CONFIG.palletBuilder.displayName,
        path: ROUTES_CONFIG.palletBuilder.path,
        roleRequired: ROUTES_CONFIG.palletBuilder.roleRequired
      },
      {
        label: ROUTES_CONFIG.shipmentManager.displayName,
        path: ROUTES_CONFIG.shipmentManager.path,
        roleRequired: ROUTES_CONFIG.shipmentManager.roleRequired
      }
    ]
  },
  {
    label: "Management",
    roleRequired: ["HEALF_MANAGEMENT_TEAM", "HEALF_OPERATIONS_TEAM"],
    children: [
      {
        label: ROUTES_CONFIG.userAccountsDashboard.displayName,
        path: ROUTES_CONFIG.userAccountsDashboard.path,
        roleRequired: ROUTES_CONFIG.userAccountsDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.vendorAccountsDashboard.displayName,
        path: ROUTES_CONFIG.vendorAccountsDashboard.path,
        roleRequired: ROUTES_CONFIG.vendorAccountsDashboard.roleRequired
      },
      {
        label: ROUTES_CONFIG.bulkEmailToVendors.displayName,
        path: ROUTES_CONFIG.bulkEmailToVendors.path,
        roleRequired: ROUTES_CONFIG.bulkEmailToVendors.roleRequired
      }
    ]
  },
  {
    // AI-309: Brand Submission is now a parent with two children — the existing dashboard
    // and a direct link to the public onboarding form so operators don't have to bookmark
    // the URL separately. Form route is the same one brands use; the nav-level role is
    // gated to HEALF_TEAM / VENDOR so it only renders in the operator sidebar.
    label: "Brand Submission",
    roleRequired: ROUTES_CONFIG.brandSubmissions.roleRequired,
    children: [
      {
        label: ROUTES_CONFIG.brandSubmissions.displayName,
        path: ROUTES_CONFIG.brandSubmissions.path,
        roleRequired: ROUTES_CONFIG.brandSubmissions.roleRequired
      },
      {
        label: "New Brand Onboarding",
        path: ROUTES_CONFIG.brandOnboarding.path,
        roleRequired: ROUTES_CONFIG.brandSubmissions.roleRequired
      }
    ]
  },
  {
    label: ROUTES_CONFIG.updateUserSettings.displayName,
    path: ROUTES_CONFIG.updateUserSettings.path,
    roleRequired: ROUTES_CONFIG.updateUserSettings.roleRequired
  },
  {
    label: ROUTES_CONFIG.info.displayName,
    path: ROUTES_CONFIG.info.path,
    roleRequired: ROUTES_CONFIG.info.roleRequired
  }
];

export default navItems;
